import { can } from "@/plugins/can";

import ProfessoresIndexPage from "@/Pages/Professores/index.vue";
import NewEditProfessorPage from "@/Pages/Professores/NewEditProfessorPage.vue";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/professores/",
    name: "professores",
    component: ProfessoresIndexPage,
    beforeEnter: checkPermission(["users.*"]),
  },
  {
    path: "/professores/create",
    name: "professores.create",
    component: NewEditProfessorPage,
    props: { editing: false },
    beforeEnter: checkPermission(["users.*"]),
  },
  {
    path: "/professores/edit/:professor_id",
    name: "professores.edit",
    component: NewEditProfessorPage,
    props: { editing: true },
    beforeEnter: checkPermission(["users.*"]),
  },
];
